
export default {
  mounted (el, binding, vnode, prevVnode) {
    console.log('--bindDirective--', el, binding, vnode, prevVnode)
    // console.log('--__--', binding.arg.total, vnode.total)

    // 下面会介绍各个参数的细节
  },
}
